export const UserAccess = "UserAccess";
export const TenantAccess = "TenantAccess";
export const LicenseAccess = "LicenseAccess";
export const ContentAccess = "ContentAccess";
export const EnterpriseAccess = "EnterpriseAccess";

export const ReadScope = "Read";
export const UpdateScope = "Update";
export const DeleteScope = "Delete";
export const CreateScope = "Create";

// Composed access scopes
export const ENTERPRISE_MANAGE = [EnterpriseAccess, UpdateScope];
